const filterTriggersContainer = document.querySelector(".js-filter-with-icon");
const triggers = document.querySelectorAll(".js-filter-with-icon__item");

if (filterTriggersContainer && triggers) {
    window.addEventListener("load", () => {
        filterTriggersContainer.addEventListener("click", (e) => {
            e.preventDefault();

            const trigger = e.target.closest(".js-filter-with-icon__item");

            if (trigger) {
                for (const trigger of triggers) {
                    trigger.classList.remove("active");
                }

                trigger.classList.add("active");
            }
        });
    });
}
